(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaai-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var q = e.target.closest('.aaai-faq__q');
  if (q) {
    var open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', String(!open));
    var a = q.parentNode.querySelector('.aaai-faq__a');
    if (a) { a.style.maxHeight = open ? '0px' : (a.scrollHeight + 'px'); }
    return;
  }
  var v = e.target.closest('.aaai-video[data-yt]');
  if (v && !v.querySelector('iframe')) {
    var id = v.getAttribute('data-yt');
    if (!id) return;
    var f = document.createElement('iframe');
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', 'beFound SEO & AI Ready demo');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    v.innerHTML = '';
    v.appendChild(f);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-projects"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.project-gallery-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: '<button class="slide-arrow prev-arrow" aria-label="prev-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.244363 7.15006L7.06168 0.332869C7.21935 0.175068 7.42984 0.0881348 7.65427 0.0881348C7.87871 0.0881348 8.08919 0.175068 8.24687 0.332869L8.74891 0.834793C9.0756 1.16185 9.0756 1.69342 8.74891 2.01998L3.02425 7.74465L8.75527 13.4757C8.91294 13.6335 9 13.8438 9 14.0681C9 14.2927 8.91294 14.5031 8.75527 14.661L8.25322 15.1628C8.09542 15.3206 7.88506 15.4075 7.66062 15.4075C7.43619 15.4075 7.22571 15.3206 7.06803 15.1628L0.244363 8.33936C0.0863123 8.18106 -0.000495911 7.9697 1.90735e-06 7.74502C-0.000495911 7.51947 0.0863123 7.30824 0.244363 7.15006Z" fill="#0A121D"/></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow" aria-label="next-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75564 7.15006L1.93832 0.332869C1.78065 0.175068 1.57016 0.0881348 1.34573 0.0881348C1.12129 0.0881348 0.910811 0.175068 0.753134 0.332869L0.251086 0.834793C-0.0755998 1.16185 -0.0755998 1.69342 0.251086 2.01998L5.97575 7.74465L0.244734 13.4757C0.0870582 13.6335 0 13.8438 0 14.0681C0 14.2927 0.0870582 14.5031 0.244734 14.661L0.746782 15.1628C0.904583 15.3206 1.11494 15.4075 1.33938 15.4075C1.56381 15.4075 1.77429 15.3206 1.93197 15.1628L8.75564 8.33936C8.91369 8.18106 9.0005 7.9697 9 7.74502C9.0005 7.51947 8.91369 7.30824 8.75564 7.15006Z" fill="#0A121D"/></svg></button>',
      autoplay: true,
      rows: 0,
      responsive: [
        {
         breakpoint: 1367,
         settings: {
                      slidesToShow: 3,
                   }
        },
        {
         breakpoint: 751,
         settings: {
                      slidesToShow: 2,
                  }
        },
        {
         breakpoint: 576,
         settings: {
                      slidesToShow: 1,
                  }
        },
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
   $('.testimonial-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: false,
      autoplay: true,
      rows: 0,
   });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
